<template>
  <div class="right-table">
    <el-table
      border
      ref="table"
      :data="info.data"
      :row-key="getRowKeys"
      :row-style="{ color: '#51627D', fontWeight: 400 }"
      :header-cell-style="{
        background: '#DCE7FA',
        color: '#343C4A',
        fontWeight: 500,
      }"
      height="375px"
      @selection-change="handleSelectionChanges"
    >
      <el-table-column
        type="selection"
        :selectable="selectInit"
        :reserve-selection="true"
        width="40"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="资源名称"
        show-overflow-tooltip
        minWidth="200"
      ></el-table-column>
      <el-table-column
        v-if="isTopLevel"
        prop="topDeptName"
        label="所属学院"
        show-overflow-tooltip
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="lastPeriodPlayNum"
        label="近7天播放量"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="info.currentPage"
      :page-size="info.size"
      :page-sizes="[10, 50, 100, 500, 1000]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="info.total"
      background
      hide-on-single-page
    />
  </div>
</template>
<script>
import { getItem } from "@/utils/storage";
export default {
  props: {
    info: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      isTopLevel: false,
      getRowKeys(row) {
        return row.uuid;
      },
    }
  },
  created() {
    let deptLevelCode = getItem("deptLevelCode");
    this.isTopLevel = deptLevelCode == "001";
  },
  methods: {
    handleSelectionChanges(rows) {
      this.$emit("HandleSelectionChanges", rows)
    },
    selectInit(row) {
      return !row.disabled;
    },
    sizeChange(size) {
      this.$emit("SizeChange", size)
    },
    pageChange(page) {
      this.$emit("PageChange", page)
    }
  }
}
</script>
<style lang="scss" scoped>
.pagination {
  padding-top: 12px;
  float: right;
}
</style>